export default __webpack_public_path__ + "static/media/sh_3.39cb3601.png";